module.exports = "/packs/2-be48d2c1eac5c44b1120ba17ba9f83cc.svg";